import React, { useState } from "react";
import ProgramData from "../../assets/data/programData";
import WordLessCard from "../../Helpers/WordLessCard/WordLessCard";
import "./Programs.css";

function Programs() {
  const [data] = useState(ProgramData);

  return (
    <section className="programs-section">
      <div className="container">
        <h3 className="program-title">Programs</h3>

        <div className="row">
          {data.map((item) => (
            <div key={item.id} className="col s12 m6 l4">
              <WordLessCard
                source={item.imgUrl}
                title={item.text}
                id={item.id}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Programs;
